import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/sessions/characterscope-solo-title.png'
import _imports_1 from '../../assets/sessions/characterscope-viewpoints-title.png'
import _imports_2 from '../../assets/brand/gyre-logo-full-pill.png'


const _hoisted_1 = { class: "report-cover-placer" }
const _hoisted_2 = {
  class: "report-cover",
  ref: "reportCover"
}
const _hoisted_3 = {
  class: "report-cover-inner",
  style: {"position":"absolute","width":"100%","height":"100%"}
}
const _hoisted_4 = { style: {"margin":"15% 10% 15% 10%"} }
const _hoisted_5 = {
  key: 0,
  class: "fake-horizontal-rule"
}
const _hoisted_6 = { style: {"font-size":"10px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { style: {"position":"relative","top":"-5px"} }
const _hoisted_9 = {
  key: 1,
  style: {"font-size":"10px","margin-top":"-5px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fake-horizontal-rule" }, null, -1)
const _hoisted_11 = {
  key: 0,
  style: {"position":"absolute","width":"50%","bottom":"2%","right":"2%"}
}
const _hoisted_12 = {
  key: 1,
  style: {"width":"75%","margin":"0 auto","position":"relative","top":"-3%"}
}
const _hoisted_13 = {
  key: 2,
  src: _imports_2,
  alt: "Gyre logo",
  style: {"width":"40%","position":"absolute","bottom":"6%","left":"10%"}
}

import { TimelineMax } from "gsap";
import { computed, getCurrentInstance, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'report-visual',
  props: {
    subjectName: {},
    reportDate: {},
    mode: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const instance = getCurrentInstance()?.proxy;
const session = instance?.$parent;

const subjectName = computed(() => props.subjectName ?? "SUBJECT NAME");
const reportDate = computed(() => props.reportDate ?? null);
const mode = computed(() => props.mode ?? "solo");

const reportVisual = ref<Element | null>(null);

const enter = (tl: TimelineMax): void => (session as any).zoomEnter(tl, reportVisual.value!);

const leave = (tl: TimelineMax): void => (session as any).zoomLeave(tl, reportVisual.value!);

__expose({ enter, leave });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "report-cover-wrapper visual side-visual report-visual",
    ref_key: "reportVisual",
    ref: reportVisual
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _imports_0,
              style: _normalizeStyle({ width: '100%', display: mode.value === 'solo' ? 'block' : 'none' }),
              alt: "solo title"
            }, null, 4),
            _createElementVNode("img", {
              src: _imports_1,
              style: _normalizeStyle({ width: '80%', display: mode.value === 'viewpoints' ? 'block' : 'none' }),
              alt: "viewpoints"
            }, null, 4),
            (mode.value === 'solo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_6, [
              _createTextVNode(_toDisplayString(subjectName.value) + " ", 1),
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, [
                _renderSlot(_ctx.$slots, "reportLeaderTypes")
              ])
            ]),
            (mode.value === 'solo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(reportDate.value ? reportDate.value : ""), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (mode.value === 'solo')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _renderSlot(_ctx.$slots, "default")
              ]))
            : _createCommentVNode("", true),
          (mode.value === 'viewpoints')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _renderSlot(_ctx.$slots, "default")
              ]))
            : _createCommentVNode("", true),
          (mode.value === 'viewpoints')
            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
            : _createCommentVNode("", true)
        ])
      ], 512)
    ])
  ], 512))
}
}

})